module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform business-loan"
  }, [_c('div', {
    staticClass: "row business-loan-box"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1"
  }, [_c('div', {
    staticClass: "business-loan-box-left-inner"
  }, [_c('h1', [_vm._v("Why partner with American Credit® for business financing?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br')])]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row user-feedback why-american-credit-custoner-voice"
  }, [_c('div', {
    staticClass: "col-2 col-lg-4",
    staticStyle: {
      "background-color": "#00234d"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10 col-lg-8",
    staticStyle: {
      "background-color": "#f6f9ff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container row user-feedback-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-10 offset-2 col-lg-5 offset-lg-0 user-feedback-content-right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/quote.png"),
      "alt": "Why American Credit Customer Voice Quote"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "user-feedback-text"
  }, [_vm._v("We need capital now to expand capacity. But the banks won't loan.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "user-feedback-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = 'tel:1855-904-0188'
      }
    }
  }, [_vm._v("Let’s Talk")]), _vm._v(" "), _vm._m(7)])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform how-works"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("See our advantages over other lenders")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Compare what you receive from American Credit versus traditional banks and other business lenders.")]), _vm._v(" "), _c('div', {
    staticClass: "row how-works-button"
  }, [_c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none",
      "margin": "7px"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "#ffffff",
      "color": "rgb(84, 86, 255)",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "1px solid rgb(84, 86, 255)",
      "margin": "7px"
    },
    on: {
      "click": function($event) {
        return this.window.open('https://youtu.be/JH96Q66Y4Hc', '_blank')
      }
    }
  }, [_vm._v("Watch Demo")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "18px",
      "line-height": "30px",
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#696969",
      "font-weight": "400"
    }
  }, [_vm._v("Get the credit you deserve from a lender you can trust. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 business-loan-box-right"
  }, [_c('img', {
    staticClass: "why-american-credit",
    attrs: {
      "src": require("../assets/imgs/why_american_credit.png"),
      "alt": "why american credit"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "#eff9ff"
    }
  }, [_c('div', {
    staticClass: "container new_bluebg benefits"
  }, [_c('h2', {
    staticClass: "text-center",
    staticStyle: {
      "margin-bottom": "37px"
    }
  }, [_vm._v("We love what you do. You’ll love how we help")]), _vm._v(" "), _c('p', {
    staticClass: "text-center benefits-p"
  }, [_vm._v("We know you want to stay focused on your business instead of burdensome applications or worrying about hidden costs. So we do the heavy lifting and bring the fast business loan to you.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('div', {
    staticClass: "row text-center benefit-items"
  }, [_c('div', {
    staticClass: "col-6 col-lg-3 pt-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/great_score.png"),
      "alt": "American Credit Business Loans Great Score"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Credit scores")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Less than perfect is OK since we look at your entire business picture—which gives us a better gauge of your success and expands our ability to offer you a loan.")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3 pt-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/convenience.png"),
      "alt": "American Credit Business Loans Convenience"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Convenience")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("This truly is business financing for the 21st Century. Our fusion of technology and financial expertise translates into ease for you - just apply online or via your smartphone using our Apps. Or just give us a call.")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3 pt-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/fast_funding.png"),
      "alt": "American Credit Business Loans Fast Funding"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Fast funding")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Many business lenders offer fast funding but with very high fees. We lend quickly and at much lower rates with asset/equipment or invoices as collateral.")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3 pt-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/personal_service.png"),
      "alt": "American Credit Business Loans Personal Service"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Personal service")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("A personal assistant is available throughout the financing process. Application, asset/invoice verification, to save you time and help with questions.")]), _vm._v(" "), _c('br')])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform how-works"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Use your funds as you choose")]), _vm._v(" "), _c('p', {
    staticClass: "text-center how-works-p"
  }, [_vm._v("Whether you’re puchasing new/pre-owned equipment, investing in seasonal inventory, looking to cover payroll, smoothing cash flow, hiring staff or doing other things to grow your business and profits, we’re ready to help.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-lg-3 pt-2"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticClass: "use-your-funds"
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "auto",
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../assets/imgs/American_Credit_Use_Your_Fund_as_You_Choose_A.png"),
      "alt": "American Credit Use Your Fund as You Choose A"
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3 pt-2"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticClass: "use-your-funds"
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "auto",
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../assets/imgs/American_Credit_Use_Your_Fund_as_You_Choose_B.png"),
      "alt": "American Credit Use Your Fund as You Choose B"
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3 pt-2"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticClass: "use-your-funds"
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "auto",
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../assets/imgs/American_Credit_Use_Your_Fund_as_You_Choose_C.png"),
      "alt": "American Credit Use Your Fund as You Choose C"
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3 pt-2"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticClass: "use-your-funds"
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "auto",
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../assets/imgs/American_Credit_Use_Your_Fund_as_You_Choose_D.png"),
      "alt": "American Credit Use Your Fund as You Choose D"
    }
  })]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 offset-lg-1",
    staticStyle: {
      "border-bottom": "1px solid #dcdcdc",
      "padding-top": "50px"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container benefits"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('h2', {
    staticClass: "text-left",
    staticStyle: {
      "margin-bottom": "26px"
    }
  }, [_vm._v("Choose the loan that’s right for you.")]), _vm._v(" "), _c('p', {
    staticClass: "text-left benefits-p-left"
  }, [_vm._v("Flexibility and control are key to success in any business. And American Credit business financing is designed to give you both. You enjoy:")]), _vm._v(" "), _c('div', {
    staticClass: "row text-left benefit-items"
  }, [_c('div', {
    staticClass: "col-12 col-lg-4 pt-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/flexible_long_terms.png"),
      "alt": "American Credit Business Loans Flexible Loan Terms"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Flexible loan terms")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("The Asset-based  Equipment loans range from $20,000 to $5M and up to 72 months. The Invoice Financing is up to $2.5M, and is an ideal short-term (30-60 days) solution.")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-4 pt-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/no_hidden_cost.png"),
      "alt": "American Credit Business Loans No Hidden Cost"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("No hidden costs")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Zero smoke and mirrors. Fees are clearly specified, rates are fixed and no costs are concealed. What you see is what you get.")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-4 pt-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/easy_management.png"),
      "alt": "American Credit Business Loans Easy Management"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Easy management")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("From accessing funds to making payments and getting support, every option is yours: Visit our site, call for assistance or use our Apps. "), _c('br'), _c('span', {
    staticStyle: {
      "color": "#5456ff"
    }
  }, [_c('a', {
    attrs: {
      "href": "/#mobile-app"
    }
  }, [_vm._v("Get the app.")])])]), _vm._v(" "), _c('br')])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 user-feedback-content-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/Why_American_Credit_Customer_Voice.png"),
      "alt": "Why American Credit Customer Voice"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "user-feedback-name"
  }, [_c('span', {
    staticStyle: {
      "color": "#6d6d6d",
      "font-weight": "300"
    }
  }, [_vm._v("Grace Bentley")]), _c('br'), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("Owner, Redwood Holiday Rentals")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "300"
    }
  }, [_vm._v("Try us now. ")]), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("See how we get you the money fast. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-efc27752"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/whyAmc.vue
// module id = 2035
// module chunks = 5